import {
  GET_AGENT_PROFILE,
  GET_AGENT_PROFILE_SUCCESS,
  GET_AGENT_PROFILE_ERROR,
  MODIFY_AGENT_PROFILE,
  MODIFY_AGENT_PROFILE_SUCCESS,
  MODIFY_AGENT_PROFILE_ERROR,
  UPLOAD_AGENT_PROFILE_IMAGES,
  UPLOAD_AGENT_PROFILE_IMAGES_SUCCESS,
  UPLOAD_AGENT_PROFILE_IMAGES_ERROR,
  GET_QUOTE_FUNNELS,
  GET_QUOTE_FUNNELS_SUCCESS,
  MODIFY_QUOTE_FUNNEL,
  MODIFY_QUOTE_FUNNEL_SUCCESS,
  MODIFY_QUOTE_FUNNEL_ERROR,
  CREATE_DEFAULT_QUOTE_FUNNELS,
  CREATE_DEFAULT_QUOTE_FUNNELS_SUCCESS,
  GET_QUOTE_FUNNELS_ERROR,
  GET_AGENT_PROFILE_POPUP_MESSAGE,
  GET_AGENT_PROFILE_POPUP_MESSAGE_SUCCESS,
  GET_AGENT_PROFILE_POPUP_MESSAGE_ERROR
} from "./actionTypes"

export const getAgentProfile = () => ({
  type: GET_AGENT_PROFILE
})

export const getAgentProfileSuccess = (payload) => ({
  type: GET_AGENT_PROFILE_SUCCESS,
  payload: payload
})

export const getAgentProfileError = (error) => ({
  type: GET_AGENT_PROFILE_ERROR,
  payload: error
})

export const getAgentProfilePopupMessage = (payload) => ({
  type: GET_AGENT_PROFILE_POPUP_MESSAGE,
  payload: payload
})

export const getAgentProfilePopupMessageSuccess = (payload) => ({
  type: GET_AGENT_PROFILE_POPUP_MESSAGE_SUCCESS,
  payload: payload
})

export const getAgentProfilePopupMessageError = (payload) => ({
  type: GET_AGENT_PROFILE_POPUP_MESSAGE_ERROR,
  payload: payload
})

export const modifyAgentProfile = (payload) => ({
  type: MODIFY_AGENT_PROFILE,
  payload: payload
})

export const modifyAgentProfileSuccess = (payload) => ({
  type: MODIFY_AGENT_PROFILE_SUCCESS,
  payload: payload
})

export const modifyAgentProfileError = (error) => ({
  type: MODIFY_AGENT_PROFILE_ERROR,
  payload: error
})

export const uploadAgentProfileImages = (agent_profile, upload_image_type) => ({
  type: UPLOAD_AGENT_PROFILE_IMAGES,
  payload: { agent_profile, upload_image_type }
});

export const uploadAgentProfileImagesSuccess = (agent_profile, upload_image_type) => ({
  type: UPLOAD_AGENT_PROFILE_IMAGES_SUCCESS,
  payload: { agent_profile, upload_image_type }
});

export const uploadAgentProfileImagesError = (error) => ({
  type: UPLOAD_AGENT_PROFILE_IMAGES_ERROR,
  payload: error
});

export const getQuoteFunnels = (payload={}) => ({
  type: GET_QUOTE_FUNNELS,
  payload: payload
})

export const getQuoteFunnelsSuccess = (action) => ({
  type: GET_QUOTE_FUNNELS_SUCCESS,
  payload: action
})

export const getQuoteFunnelsError = (error) => ({
  type: GET_QUOTE_FUNNELS_ERROR,
  payload: error
})

export const modifyQuoteFunnel = (payload) => ({
  type: MODIFY_QUOTE_FUNNEL,
  payload: payload
})

export const modifyQuoteFunnelSuccess = (payload) => ({
  type: MODIFY_QUOTE_FUNNEL_SUCCESS,
  payload: payload
})

export const modifyQuoteFunnelError = (error) => ({
  type: MODIFY_QUOTE_FUNNEL_ERROR,
  payload: error
})

export const createDefaultQuoteFunnels = () => ({
  type: CREATE_DEFAULT_QUOTE_FUNNELS
})

export const createDefaultQuoteFunnelsSuccess = (payload) => ({
  type: CREATE_DEFAULT_QUOTE_FUNNELS_SUCCESS,
  payload: payload
})